exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singleSelectHeader__closeButton___1ncjf {\n  font-size: 20px;\n  color: #828282;\n  margin-top: 6px; }\n\n.singleSelectHeader__header___WDtbW {\n  padding-bottom: 17px;\n  box-shadow: 0 1px 0 0 #dbdbdb;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n\n.singleSelectHeader__title___1W1wj {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #292929; }\n\n.singleSelectHeader__clearButton___iqdIl {\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  display: inline-block;\n  margin-right: 20px; }\n", ""]);

// exports
exports.locals = {
	"closeButton": "singleSelectHeader__closeButton___1ncjf",
	"header": "singleSelectHeader__header___WDtbW",
	"title": "singleSelectHeader__title___1W1wj",
	"clearButton": "singleSelectHeader__clearButton___iqdIl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleSelectModal/SingleSelectHeader/singleSelectHeader.scss
// module id = 1722
// module chunks = 6